import React from "react";
import GasFeesTable from "./GasFeesTable";
import NetworkGasFeesTable from "../NetworkGasFees/NetworkGasFeesTable";
import Index from "./index";

const GasFees = () => {
    const { gasFees, networkGasFees } = Index();

    return (
        <>
            <GasFeesTable heading="Gas Fee Currencies" gasFees={gasFees} />
            <div style={{ marginTop: "2rem" }}>
                <NetworkGasFeesTable heading="Network Configuration" networkGasFees={networkGasFees} />
            </div>
        </>
    );
};

const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname && prevProps.colorMode === nextProps.colorMode;
};
export default React.memo(GasFees, comparisonFn);
